module.exports = __webpack_public_path__ + "static/media/summer-castel2.53a666ec.png";